import React from 'react';
import { useTranslation } from 'react-i18next';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { SHOW_COMPANY_GROUPS_HEADER } from '@rd-web-markets/market/dist/constants';
export function CompanyPageHeader(_ref) {
  let {
    page
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    variant: "tabs",
    className: "pb-1"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'company_page',
    to: `/${user.account_type}`
  }, t('companies'))), SHOW_COMPANY_GROUPS_HEADER && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: page === 'company_groups_page',
    to: `/${user.account_type}/company_groups`
  }, t('company_groups')))));
}